<template>
  <div></div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        image: {
            type: String,
            default: null,
            required: false
        },
        priceRange: {
            type: String,
            required: true
        },
        region: {
            type: String,
            required: false
        },
        locality: {
            type: String,
            required: false
        },
        streetAddress: {
            type: String,
            required: false
        },
        fullAddress: {
            type: String,
            default: null,
            required: false
        },
        telephone: {
            type: String,
            required: true
        },
        urlTemplate: {
            type: String,
            required: true
        },
    },
    mounted() {
        this.createShopDetailSchema();
    },
    methods: {
        async createShopDetailSchema() {
            if (this.fullAddress) {
                await this.getGeoCoordinates();
            }
            this.generateJsonScript();
        },
        generateJsonScript() {
            const head = document.getElementsByTagName('head')[0];
            let script = document.querySelector('script[type="application/ld+json"]');
            script = document.createElement('script');
            script.type = 'application/ld+json';

            const schema = {
                '@context': 'http://schema.org',
                '@type': 'LocalBusiness',
                '@id': this.id,
                'name': this.name,
                'description': this.description,
                'priceRange': this.priceRange,
                'telephone': this.telephone,
                'potentialAction': {
                    '@type': 'ReserveAction',
                    'target': {
                        '@type': 'EntryPoint',
                        'urlTemplate': this.urlTemplate,
                        'inLanguage': 'ja-JP',
                        'actionPlatform': [
                            'http://schema.org/DesktopWebPlatform',
                            'http://schema.org/IOSPlatform',
                            'http://schema.org/AndroidPlatform'
                        ]
                    }
                },
                'geo': this.shopDetailSchema.geo || {}
            };

            if (this.image) {
                schema.image = this.image;
            }

            if (this.region && this.locality && this.streetAddress) {
                schema.address = {
                    '@type': 'PostalAddress',
                    'addressRegion': this.region,
                    'addressLocality': this.locality,
                    'streetAddress': this.streetAddress,
                    'addressCountry': 'JP'
                };
            }

            this.shopDetailSchema = Object.assign(this.shopDetailSchema, schema);
            script.text = JSON.stringify(this.shopDetailSchema);
            head.appendChild(script);
        },
        getGeoCoordinates() {
            return new Promise((resolve, reject) => {
                const geocoder = new google.maps.Geocoder();
                const params = {
                    address: this.fullAddress,
                    region: 'jp'
                };
                geocoder.geocode(params, (results, status) => {
                    if (status !== google.maps.GeocoderStatus.OK) {
                        resolve();
                        return;
                    }
                    const location = results[0].geometry.location;
                    this.shopDetailSchema.geo = {
                        '@type': 'GeoCoordinates',
                        'latitude': location.lat(),
                        'longitude': location.lng()
                    };
                    resolve();
                });
            });
        }
    },
    data() {
        return {
            shopDetailSchema: {}
        }
    }
}
</script>
